import React, { Component } from 'react';
import { Layout } from '@bit/bit.rendering.constants.layouts';
import { FatSplitter } from '../../atoms/split-pane/splitter/flavors/fat-splitter';
import { CollapsibleSplitter } from '../../atoms/split-pane/splitter/flavors/collapsible-splitter';
import { TupleSplitPane } from '../../atoms/tuple-split-pane';
import { LayoutProps } from './homepage-template';

import styles from './homepage-template.module.scss';

export class DesktopTemplate extends Component<LayoutProps> {
	// constructor(props: LayoutProps) {
	// 	super(props);
	// 	this.state = {
	// 		showFileExplorer: !isMobile(),
	// 		terminalDrawer: !isMobile(),
	// 	};
	// }
	// toggleBottomDrawer = (isOpen: boolean) => {
	// 	this.setState({ terminalDrawer: isOpen });
	// };
	// toggleFileExplorer = () => {
	// 	this.setState({ showFileExplorer: !this.state.showFileExplorer });
	// };
	// LayoutContextValue = {
	// 	toggleSidebar: () => this.toggleFileExplorer(),
	// };
	render() {
		const { layout: masterLayout } = this.props;
		return ( 
			<div className={styles.pageLayout}>
				{this.props.controlBoard}

				<TupleSplitPane
					min={3.4}
					max={38}
					ratio={14.5}
					layout={Layout.row}
					Splitter={CollapsibleSplitter}
				>
					{this.props.fileExplorer}

					<TupleSplitPane
						min={14.5}
						ratio={76.4}
						layout={Layout.column}
						Splitter={CollapsibleSplitter}
					>
						<TupleSplitPane
							min={3.4}
							max={85}
							ratio={62}
							layout={masterLayout}
							Splitter={FatSplitter}
						>
							{this.props.editor}
							{this.props.player}
						</TupleSplitPane>

						{this.props.terminal}
					</TupleSplitPane>
				</TupleSplitPane>
			</div>
		);
	}
}
